import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import GuestGate from "@/guest/GuestGate";
import AdminApp, { AdminSignIn } from "@/admin/AdminApp";

const WithClerk = ({ children }) => <ClerkAuthProvider>{children}</ClerkAuthProvider>;

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Routes>
        <Route path="/" element={<GuestGate />} />
        <Route path="/f/:linkToken" element={<GuestGate />} />
        <Route path="/preview/:previewToken" element={<GuestGate />} />
        <Route path="/sign-in/*" element={<WithClerk><AdminSignIn mode="in" /></WithClerk>} />
        <Route path="/sign-up/*" element={<WithClerk><AdminSignIn mode="up" /></WithClerk>} />
        <Route path="/admin/*" element={<WithClerk><AdminApp /></WithClerk>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
